import { createAction } from 'redux-actions';

const PREFIX = 'AUTH';

export const setLang = createAction(`${PREFIX}/setLang`);
